import model from './model';
import { EmergencyScenarioCreatePage } from './pages/EmergencyScenarioCreatePage';
import { EmergencyScenarioDetailsPage } from './pages/EmergencyScenarioDetailsPage';

model.routes.setRoutes({
  createRoute: {
    component: EmergencyScenarioCreatePage,
  },
  detailsRoute: {
    component: EmergencyScenarioDetailsPage,
  },
  editRoute: {
    enabled: () => false,
  },
});
